<template>
  <div class="mt-2">
    <v-divider></v-divider>
    <p class="headline  red--text">
      Račun je zaključan!!
    </p>
      <v-row no-gutters>
        <v-col cols="12">
            Korisnik zaključao: {{ documentLockedBy }}
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
            Datum zaključavanja: {{ locUpdateDate }}, {{ locUpdateTime }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
             {{ RespondedMessage }}
        </v-col>
      </v-row>

  </div>
</template>

<script>
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import { mapGetters } from 'vuex'
import moneyFormat from '@/snippets/moneyFormat'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      document: {},
      lang: {},
      langC: {},
      documentNameLoc: '',
      docSide: 3,
      locUpdateDate: null,
      locUpdateTime: null,
      documentLockedBy: null,
      RespondedMessage: ''
    }
  },
  mounted() {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    if (this.$store.state.documentActivHead) {
      this.document = this.$store.state.documentActivHead
      this.documentNameLoc = this.$store.state.documentActivLoc
    }
     if (this.$store.state.documentSide) {
        this.docSide = this.$store.state.documentSide
      }
      this.documentLockedBy = this.document.documentLockedBy ? this.document.documentLockedBy : ''
      this.locUpdateDate = dayjs(this.document.documentLockedDate).format('DD.MM.YYYY')
      this.locUpdateTime = this.document.documentLockedTime
      this.RespondedMessage = this.document.RespondedMessage
  },
  methods: {
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
  },
  computed: {
    ...mapGetters({
      mySum: 'NeedDocumentActivHead'
    }),
  },
   watch: {
    'mySum' () {
      this.document = this.$store.state.documentActivHead
    },
  },
}
</script>

<style>

</style>